module.exports = __webpack_public_path__ + "media/3.17dd5c4a.mp3";